import * as React from 'react'
import * as classNames from 'classnames'

import { Review } from '~/atoms/text/Review'

import PhoneIcon from './phone.svg?reactCompornt'

import * as Style from './style.css'

export interface IProps {
  catchcopy: string
  specialtyConsultations: string
  pricePerMinute: number
  reviewScore: number
  reviewCount: number
  imageUrl: string
  showUrl: string
  editUrl: string
  progressCounseling: boolean
  nowStatus: boolean
  certs: string[]
  certsIncludeTraining: boolean
}

export const CounselingCard = ({
  catchcopy,
  specialtyConsultations,
  pricePerMinute,
  reviewScore,
  reviewCount,
  imageUrl,
  showUrl,
  editUrl,
  progressCounseling,
  nowStatus,
  certs,
  certsIncludeTraining,
}: IProps): JSX.Element => {
  const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    e.stopPropagation()
    location.href = editUrl
  }

  return (
    <a className={Style.Card} href={showUrl}>
      <div className={Style.Wrapper}>
        <div className={Style.Head}>
          <img className={Style.Thumbnail} src={imageUrl} />
          <p className={Style.Catchcopy}>{catchcopy}</p>
        </div>
        <div className={Style.Certifications}>
          {certs.map((text, index) => (
            <span className={Style.Certification} key={index}>
              {text}
            </span>
          ))}
          {certsIncludeTraining && (
            <span className={Style.Certification}>指定研修修了</span>
          )}
        </div>
        <ul className={Style.Reviews}>
          <li>
            <Review type="support" score={reviewScore} count={reviewCount} />
          </li>
        </ul>
        <p className={Style.Description}>
          【得意な相談】{specialtyConsultations}
        </p>
        {nowStatus && progressCounseling && (
          <span className={Style.DisableLink}>相談中</span>
        )}
        {nowStatus && !progressCounseling && (
          <span className={Style.Link} onClick={handleButtonClick}>
            今すぐ相談
          </span>
        )}
      </div>
      <div className={Style.Footer}>
        <ul className={Style.HourlyWages}>
          <li className={Style.HourlyWage}>
            <PhoneIcon className={Style.HourlyWageIcon} />
            {pricePerMinute}円/分
          </li>
        </ul>
      </div>
    </a>
  )
}
